(function (g, $) {
    "use strict";
    var HW = g.HW = g.HW || {};
    HW.currency = HW.currency || {};

    HW.currency = {
        getSymbol: function(code) {
            var DEFAULT_SYMBOL = '$';
            var CODE_TO_SYMBOL = {
                'USD': '$',
                'GBP': '£',
                'AUS': 'A$',
                'CAD': 'C$'
            };

            return CODE_TO_SYMBOL[code] || DEFAULT_SYMBOL
        },
        // returns the given number with two decimals if it's float, else just the value
        getLocalizedMoneyValue: function(value,code){
            var CONVERSION_RATE = {
                'USD': 1,
                'GBP': 0.77,
                'AUS': 1.6784949,
                'CAD': 1.5015
            };

            var result = (value * CONVERSION_RATE[code||'USD']);
            if (result % 1 !== 0) {
                result = result.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            return result;
        },
        getMoneyValueWithSymbol: function(value,code){
            return this.getSymbol(code) + this.getLocalizedMoneyValue(value,code);
        }
    }

}(this, jQuery));
